// src/Pages/Landing/JoyrideHelsinkiLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";

export default function JoyrideHelsinkiLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Helsinki"
      maakunta="Uusimaa"
      nearbyAreas={[
        "Vantaa",
        "Espoo",
        "Kerava",
        "Järvenpää",
        "Sipoo",
        "Tuusula"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Helsingissä tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Helsinki sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja yksityistilaisuuksiin, kun juhliin halutaan energinen livebändi."
      logisticsText="Bilebändi Joyride tulee Keski-Uudeltamaalta, joten Helsinkiin on luonteva ja selkeä keikkamatka. Bändillä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
    />
  );
}